<template>
  <nav>
    <el-aside style="width: 100%" :class="this.$route.path == '/parameterSetting' ? 'elAside' : ''">
      <el-menu :default-active="activePath" class="el-menu-demo" mode="horizontal"
        background-color="rgba(16, 17, 22, 1)" text-color="rgba(255, 255, 255, 1)"
        active-text-color="rgba(255, 255, 255, 1)">
        <template v-for="item in roleMenuData">
          <el-submenu v-if="item.children" :index="item.id + ''" :key="item.id">
            <template slot="title">
              <span class="asideSpan">{{ item.name }}</span>
            </template>
            <el-menu-item class="menu-sublist-item" v-for="subItem in item.children" :index="subItem.menuUrl"
              :key="subItem.id" @click="saveNavState(subItem.menuUrl)">
              <span class="subItemSpan">{{ subItem.name }}</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :key="'else-' + item.id" :index="item.menuUrl" @click="saveNavState(item.menuUrl)">
            <span slot="title" class="asideSpan">{{ item.name }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-aside>
  </nav>
</template>
<script>
import store from "@/store/index.js";

export default {
  name: "NavBar",
  created() {
    // this.getMenuList();
    if (this.$route.path === "/ai/control") {
      this.activePath = "/ai/control";
    } else {
      this.activePath = sessionStorage.getItem("activePath");
    }
  },
  data() {
    return {
      roleMenuData: [
        {
          "name": "AI Smart Control",
          "menuUrl": "/ai/control",
          "code": "AIControl",
        },
        {
          "name": "AI Alerts",
          "menuUrl": "/warningCenter",
          "code": "AIAlarmCenter",
        },
        {
          "name": "IoT Devices",
          "menuUrl": "/IoTDevices",
          "code": "IOTEquipmentCenter",
        },
        {
          "name": "Algorithm Tuning",
          "menuUrl": "/parameterSetting",
          "code": "parameterSetting",
        },
      ],
      activePath: sessionStorage.getItem("activePath") || "/ai/control",
      moudel: "a",
    };
  },
  watch: {
    "$store.state.displayMode"(newVal, oldVal) {
      this.moudel = newVal;
      if (oldVal) {
        if (this.moudel == "dataMode") {
          sessionStorage.setItem("activePath", "/ai/control");
          this.$router.push("/ai/control1");
        } else {
          sessionStorage.setItem("activePath", "/ai/control");
          this.$router.push("/ai/control");
        }
      }
    },
  },
  methods: {
    getMenuList() {
      const roleMenuData = store.state.roleMenuData;
      if (roleMenuData && roleMenuData.length) {
        this.roleMenuData = roleMenuData;
      } else {
        this.roleMenuData = [];
      }
    },
    saveNavState(activePath) {
      console.log(activePath);
      this.activePath = activePath;
      sessionStorage.setItem("activePath", activePath);
      this.$router.push(activePath);
      if (activePath == "/ai/control") {
        sessionStorage.setItem("activePath", activePath);
        this.$router.push("/ai/control");

        const homeUrl = sessionStorage.getItem("homeurl");
        switch (true) {
          case homeUrl == 1:
            this.$store.commit("setDisplayMode", "dataMode");
            sessionStorage.setItem("displayMode", "dataMode");
            break;
          case homeUrl == 2:
            this.$store.commit("setDisplayMode", "boardMode");
            sessionStorage.setItem("displayMode", "boardMode");
            break;
          case homeUrl == 3:
            this.$store.commit("setDisplayMode", "aiEyes");
            sessionStorage.setItem("displayMode", "aiEyes");
            break;
        }
      } else {
        this.activePath = activePath;
        sessionStorage.setItem("activePath", activePath);
        this.$router.push(activePath);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-aside {
  overflow: hidden !important;
  height: 60px;
}

nav .el-menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

nav .el-menu-item.is-active {
  border: none;

  .asideSpan {
    padding-bottom: 2px;
    border-bottom: 2px solid rgba(252, 247, 247, 1);
  }
}

nav .el-menu-item:hover {
  background: rgba(38, 87, 143, 1) !important;

  .asideSpan {
    padding-bottom: 2px;
    border-bottom: 2px solid rgba(252, 247, 247, 1);
  }
}

::v-deep .el-submenu {
  .el-submenu__title:hover {
    background: rgba(38, 87, 143, 1) !important;

    .asideSpan {
      padding-bottom: 2px;
      border-bottom: 2px solid rgba(252, 247, 247, 1);
    }
  }
}

::v-deep .el-menu--horizontal {
  height: 100%;

  .el-submenu.is-active {
    .el-submenu__title {
      color: #fff;
      border: none;

      .asideSpan {
        padding-bottom: 2px;
        border-bottom: 2px solid #fff;
      }
    }
  }
}

.asideSpan {
  margin: 0 10px;
  font-size: 14px;
  font-weight: 400;
}

.subItemSpan {
  margin-left: 18px;
}

:root[theme="light"] html .el-submenu__title,
:root[theme="light"] body .el-submenu__title,
:root[theme="light"] #app .el-submenu__title {
  background-color: #fafafc !important;
}
</style>

<style lang="scss">
.el-menu--horizontal {
  .menu-sublist-item.is-active {
    .subItemSpan {
      padding-bottom: 2px;
      border-bottom: 2px solid #fff;
    }
  }
}
</style>
